"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = exports.default = void 0;
var _core = require("@material-ui/core");
const defaultOptions = exports.defaultOptions = {
  noSsr: true
};
const useDevice = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
  return {
    isMobile: (0, _core.useMediaQuery)(theme => theme.breakpoints.down('sm'), options),
    isTablet: (0, _core.useMediaQuery)(theme => theme.breakpoints.only('md'), options),
    isDesktop: (0, _core.useMediaQuery)(theme => theme.breakpoints.up('lg'), options)
  };
};
var _default = exports.default = useDevice;